 
export const VoluntaryTimeOffType = Object.freeze({
    SingleDay: 0,
    BlockOfDays: 1,
    TimePeriod: 2,
});
